import React, {MouseEventHandler, VoidFunctionComponent} from 'react';
import cx from 'classnames';

import styles from './chip.module.css';

interface Props {
  title: string;
  isActive?: boolean;
  isFilter?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const Chip: VoidFunctionComponent<Props> = props => {
  const {onClick, isActive, isFilter} = props;
  const clickable = Boolean(onClick);

  return (
    <>
      {clickable ? (
        <button
          className={cx(
            styles.chip,
            styles.clickable,
            isActive && styles.isActive,
            isFilter && styles.isFilter
          )}
          onClick={onClick}>
          {props.title}
        </button>
      ) : (
        <div className={styles.chip}>{props.title}</div>
      )}
    </>
  );
};

export default Chip;
